import React, { Component } from 'react';
import { I18n } from 'aws-amplify';
import { connect } from 'react-redux';
import { Redirect, withRouter } from "react-router-dom";
import styled from 'styled-components';

import '../../App.css';

import logo from '../../image/logoWOtext.svg';
import Footer from '../../components/page-templates/footer';
import TopMenuSignup from '../../components/page-templates/_top-menu-signup';

import ChatNavBarItem from '../../components/shared/chat-navbar-item';

import Loading from '../../components/pages/loading';

import { scrollToTop } from '../../utils/ui';

const mapStateToProps = state => {
    return state;
};

const mapDispatchToProps = dispatch => {
    return {
    };
};

const ContainerPage = styled.div`
    .logged-page {
        background: #fff;

        &.page-grey {
            background: #f7f7f7;
            height: 100%;
            position: relative;
            width: 100%;
        }
    }

    .page-whatif {
        height: 100%;
    }
`

class WrapperRegister extends Component {

    componentDidMount() {
        scrollToTop();
    }


    constructor(props) {
        super();
        this.state = {
        };
    }

    render() {

        const isInit = (!this.props.auth || this.props.auth.init);

        if (isInit) {
            return (<Loading />);
        }

        const isNotLogged = (this.props.auth && !this.props.auth.logged_user);
        const IsLogout = (this.props.auth && this.props.auth.is_logout);

        if (isNotLogged) {

            const login = {
                pathname: '/login',
                state: {
                    returnUrl: (IsLogout ? '' : this.props.location.pathname),
                }
            }

            return (<Redirect to={login}></Redirect>);
        }

        return (
            <ContainerPage>

                <section className={`hero logged-page ${this.props.noFullHeight ? '' : 'is-fullheight'}`}>
                    <div className={`hero-head ${this.props.noFixed ? '' : 'is-fixed'}`}>


                        <nav className="navbar is-main navbar-main">
                            <div className="container">

                                <div id="navbarMenu" className="navbar-menu navbar-menu-new is-active">
                                    <div className="navbar-start">
                                        {/* <TopMenu {...this.props} />  */}
                                    </div>
                                    <div className="navbar-logo">
                                        <div className="navbar-item">
                                            <a href="/"><img src={logo} alt="Ollo" className="logo"/></a>
                                        </div>
                                    </div>

                                    <div className="navbar-end" style={{ zIndex: 999 }}>
                                        <TopMenuSignup {...this.props} />
                                    </div>
                                </div>
                            </div>
                        </nav>

                        {/* <nav className="navbar is-main navbar-main">
                            <div className="container">
                                <div className="navbar-brand is-expanded">
                                    <a className="navbar-item" href="/">
                                        <img src={logo} alt="Ollo" />
                                    </a>
                                    <span className="navbar-burger burger" data-target="navbarMenu">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </span>
                                </div>
                                <div id="navbarMenu" className="navbar-menu is-active">
                                    <div className="navbar-start">
                                        <div className="navbar-item">
                                        </div>
                                    </div>

                                    <div className="navbar-end" style={{ zIndex: 999 }}>
                                        <TopMenuSignup {...this.props} />
                                    </div>
                                </div>
                            </div>
                        </nav> */}
                        {/* <SubMenu {...this.props} /> */}
                    </div>
                    <div className="" style={{padding:"60px 0 0 0"}}>
                        {this.props.children}
                    </div>

                </section>

                <Footer {...this.props} />

            </ContainerPage>

        );
    }
}



export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(WrapperRegister));
